import { j as a, c as m } from "./utils-BdNIfrGQ.js";
import { n } from "./normalize-spacing-DY0KSpr_.js";
import { S as r } from "./skeleton-CpjuZTJp.js";
const t = ({ className: o, spacing: e, ...s }) => /* @__PURE__ */ a.jsx(r, { className: m("rounded-md", o, n(e)), ...s });
t.displayName = "DivSkeleton";
export {
  t as D
};
